import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import RootDataTable, {
  Props as RootDataTableProps,
} from '@components/DataTable';
import { RouterLink } from '@redux-first-router-link';

export interface Props extends RootDataTableProps {
  disabled?: boolean;
}

export default styled(RootDataTable)<Props>`
  border-color: ${({ theme }) => theme.color.whiteRGBA(0.1)};
  padding: ${({ theme }) => `0 ${theme.x1spacePx}px ${theme.x1spacePx}px`};
  thead tr th {
    background: transparent;
    ${({ theme }) => theme.typography.tinyStrong};
    color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  }
  tr {
    height: auto;
  }
  th,
  td {
    border-top-color: ${({ theme }) => theme.color.whiteRGBA(0.1)};
    vertical-align: middle;
  }
  th {
    padding: ${({ theme }) => `10px ${theme.x1spacePx}px`};
  }
  td {
    ${({ theme }) => theme.typography.xSmall};
    padding: 0;
    ${({ disabled }) => disabled && `background: none !important;`}
  }
  > tbody > tr {
    > td {
      background: transparent;
      transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1);
      > a,
      > span {
        display: block;
        padding: ${({ theme }) => `10px ${theme.x1spacePx}px`};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-decoration: none;
        color: inherit;
        cursor: ${({ disabled }) => (disabled ? `auto` : `pointer`)};
      }
    }
    ${media.lgUp`
      &:hover {
        > td {
          background: ${({ theme }) => theme.color.whiteRGBA(0.05)};
        }
      }
      &:active {
        > td {
          background: ${({ theme }) => theme.color.whiteRGBA(0.1)};
        }
      }
    `}
  }
`;

export const CellLink = styled(RouterLink)`
  display: block;
  padding: ${({ theme }) => theme.x1spacePx}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
  color: inherit;
`;

export const SubTable = styled('table')<Props>`
  width: 100%;
  table-layout: auto;
  border-spacing: 0;
  tr {
    height: auto;
    &:not(:only-child) {
      &:first-child {
        td a {
          padding-bottom: 0;
          transition: none !important;
        }
      }
      &:last-child {
        td a {
          padding-top: 0;
          transition: none !important;
        }
      }
    }
  }
  td {
    padding: 0;
    border-color: transparent;
    border: none;
    ${({ disabled }) => disabled && `background: none;`}
  }
`;
